export default __webpack_public_path__ + "static/ripple_glow_-43f02c980071b1caee71abc899875cd8.gif";